import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GRIN_SCOPE_MAX_IN_ORDER, GRIN_SCOPE_MIN_IN_ORDER } from 'consts/billingConsts'

const useScopeOrderValidation = scopeInputs => {
  const { t } = useTranslation()
  const [limitErrorKey, setLimitErrorKey] = useState(null)
  const formErrors = {}
  let totalQuantity = 0
  let firstOverLimitKey

  scopeInputs.forEach(({ key, quantity, maxQuantity }) => {
    const parsedQuantity = Number(quantity)
    if (!Number.isFinite(parsedQuantity) || parsedQuantity < 0) {
      formErrors[key] = t('dialogs.orderScopes.quantityError')
      return
    }

    totalQuantity += parsedQuantity
    if (!firstOverLimitKey && totalQuantity > GRIN_SCOPE_MAX_IN_ORDER) {
      firstOverLimitKey = key
    }

    if (parsedQuantity > 0 && parsedQuantity % GRIN_SCOPE_MIN_IN_ORDER !== 0) {
      formErrors[key] = t('dialogs.orderScopes.quantityMultiplyError')
    } else if (parsedQuantity > maxQuantity) {
      formErrors[key] = t('dialogs.orderScopes.maxquantityError', { maxScopes: maxQuantity })
    }
  })

  if (!scopeInputs.some(({ quantity }) => Number(quantity) > 0)) {
    formErrors.quantity = t('dialogs.orderScopes.quantityError')
  }

  if (totalQuantity > GRIN_SCOPE_MAX_IN_ORDER) {
    // A restored draft has no edited field. Use the first row that takes its total over the limit.
    const errorKey =
      scopeInputs.find(({ key, quantity }) => key === limitErrorKey && Number(quantity) > 0)?.key || firstOverLimitKey
    formErrors[errorKey] = t('dialogs.orderScopes.totalQuantityError', { maxScopes: GRIN_SCOPE_MAX_IN_ORDER })
  }

  const onQuantityChange = ({ type, quantity }) => {
    const input = scopeInputs.find(input => input.type === type)
    if (!input) return

    const nextTotal = totalQuantity - Number(input.quantity) + Number(quantity)
    if (nextTotal <= GRIN_SCOPE_MAX_IN_ORDER) {
      setLimitErrorKey(null)
    } else if (totalQuantity <= GRIN_SCOPE_MAX_IN_ORDER) {
      setLimitErrorKey(input.key)
    }
  }

  const isValid = Object.keys(formErrors).length === 0
  const validateForm = useCallback(() => isValid, [isValid])
  const resetValidation = useCallback(() => setLimitErrorKey(null), [])

  return { formErrors, validateForm, onQuantityChange, resetValidation }
}

export default useScopeOrderValidation
